__turbopack_context__.v({
  "arrow": "_9ENEQa_arrow",
  "arrowDown": "_9ENEQa_arrowDown",
  "arrowUp": "_9ENEQa_arrowUp",
  "peerWrapper": "_9ENEQa_peerWrapper",
  "tableData": "_9ENEQa_tableData",
});
